import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";


import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import { AuthContext } from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomTopPayorDetail from "src/components/manufacturer/customTopPayorDetail";
import CustomComponentAreaCaseBySubmission from "src/components/manufacturer/customComponentAreaCaseBySubmission";
import CaseVolumeColumnChart from "src/components/manufacturer/caseVolumeColumnChart";
import { StatisticsApiResponse } from "../manufacturer/types";
import { isZilrettaUser } from "src/helpers";


const PracticeStats: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData, destroySession } = useContext(AuthContext);
  const navigate = useNavigate()
  const [searchParams, updateSearchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const insuranceName:string | null = params.get('insurance_name');
  const [drug,setDrugName] = useState<string>(params.get('drug') || "");

  const [queryParams, changeQueryParams] = useState({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter_type: searchParams.get("filter") || "",
    // time: searchParams.get("time") || "",
    type: "territories",
    role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || "",
    soc_value: searchParams.get("soc_value") || "",
    drug_id: searchParams.get("drug_id") || drug  === 'iovera'? 'iovera°' : drug ||  isZilrettaUser(userData) ? "zilretta" :  "",
    id: searchParams.get("userId") || (userData && userData.ref_type?.toLowerCase() !== "manufacturer" ? userData.id.toString() : "") || "",
    insurance_name:insuranceName,
    case_id:"",
     global_patient_id:""

  });

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.message && statisticsData.message.includes("User is a physician user")) {
        showToast(["Your session is expred. Please sign in again to continue", "Your role has been updated from another session."], ToastTypes.INFO)
        destroySession()
        navigate("/users/sign_in")
      }
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        // time: "",
        type: "territories",
        role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || "",
        soc_value: "",
        drug_id: drug  === 'iovera'? 'iovera°' : drug,
        id: "",
        insurance_name:'',
        case_id:"",
         global_patient_id:""

      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = (period: string) => {
    const updatedQueries = {
      ...queryParams,
      drug_id: drug  === 'iovera'? 'iovera°' : drug,
      period,
    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
       <div 
        className={`container-fluid body-bg overflow-y-auto ${drug === "iovera" ? 'iovera-content' : drug === "zilretta" ? 'zilretta-content' : ''}`} >
        <AuthMaunfacturerSubHeader/>
        {statisticsData && (
            <CaseFilter
                defaultQueryParams={queryParams}
                updateQueryParams={updateQueryParamsAndCallAPI}
            />
        )}
        {statisticsData && (
            <CaseVolumeColumnChart StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
                                   buttonShows={false}/>
        )}
        {statisticsData && (
            <CustomTopPayorDetail startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} drug={''}/>
        )}
        <div className="row">
          <div className="co-12">
            <div className="card mt-3">
              <div className="card-header">
                <h5 className="m-0 text-center text-primary">Transfers
                </h5>
              </div>
              <div className="card-body">
                <h6 className="text-center">
                  18.143% (14.460%)
                </h6>
              </div>
            </div>
          </div>
        </div>

        {statisticsData && (
            <CustomComponentAreaCaseBySubmission startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} title={"Doctors"} drug={''}/>
        )}

        <FooterText footerType="black"/>
      </div>
  );
};

export default PracticeStats;
